import { NavLink } from "./NavLink";
import { Heart, BookHeart } from "lucide-react";

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-card/80 backdrop-blur-md border-b border-border shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-2">
            <Heart className="w-6 h-6 !text-primary" fill="currentColor" />
            <span className="font-romantic text-2xl !text-primary">Gab & Ana</span>
          </div>
          
          <div className="flex gap-1">
            <NavLink
              to="/"
              className="px-4 py-2 rounded-lg font-serif text-foreground transition-all duration-300 hover:bg-primary/10"
              activeClassName="bg-primary/20 !text-primary font-semibold"
            >
              Home
            </NavLink>
            <NavLink
              to="/albums"
              className="px-4 py-2 rounded-lg font-serif text-foreground transition-all duration-300 hover:bg-primary/10 flex items-center gap-2"
              activeClassName="bg-primary/20 !text-primary font-semibold"
            >
              <BookHeart className="w-4 h-4" />
              Álbuns
            </NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
